import { TRiskIdIdCode } from "./riskIdIdCode";

export type IRiskTypings = {
    riskProcesses: TRiskIdIdCode[];
    riskStandards: TRiskIdIdCode[];
    riskStakeholders: TRiskIdIdCode[];
}

export class RiskTypings implements IRiskTypings {
    riskProcesses: TRiskIdIdCode[];
    riskStandards: TRiskIdIdCode[];
    riskStakeholders: TRiskIdIdCode[];

    constructor();
    constructor(obj: IRiskTypings);
    constructor(obj?: any) {
        this.riskProcesses = obj?.riskProcesses ?? [];
        this.riskStandards = obj?.riskStandards ?? [];
        this.riskStakeholders = obj?.riskStakeholders ?? [];
    }
}